module.exports = __webpack_public_path__ + "img/techSFC_EN.jpg";